export default __webpack_public_path__ + "static/media/add-or-remove-from-list-circle.8e777cb7.svg";